import React from 'react';
import styled from 'styled-components';

import { colors } from 'styles/colors';

const VerticalFooter = () => (
   <Wrapper>
      <Address>
         <AddressItem>Jana Kilińskiego 75</AddressItem>
         <AddressItem>95-083 Kazimierz</AddressItem>
         <AddressItem>+48 43 677 50 63</AddressItem>
         <AddressItem>biuro@konsport.com.pl</AddressItem>
      </Address>
      <Copyright>&copy; Konsport</Copyright>
   </Wrapper>
);

const Wrapper = styled.footer`
   width: 100%;
   color: ${colors.neutral40};
   font-size: 12px;
   margin: 0;
   padding-bottom: 20px;
`;

const Copyright = styled.span`
   display: block;
`;

const Address = styled.address`
   padding: 0;
   margin: 40px 0 20px;
   font-size: inherit;
`;

const AddressItem = styled.span`
   display: block;
   font-size: inherit;
`;

export default VerticalFooter;
